import { render } from "./shopping-center.vue?vue&type=template&id=7ce07c8f"
import script from "./shopping-center.vue?vue&type=script&lang=js"
export * from "./shopping-center.vue?vue&type=script&lang=js"

import "./shopping-center.vue?vue&type=style&index=0&id=7ce07c8f&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__